import React from 'react'
import { Outlet, useLocation } from 'react-router'
import { HotsiteFooter } from '../../../domain/feature/hotsite/Footer'
import { HotsiteHeader } from '@zing/shared/domain/feature/hotsite/Header'
import { ROUTES } from '@zing/shared/constants'
import { HotsiteContentWrapper, HotsitePageWrapper } from '../../../../../white-label/src/main/pages/defaults/styles'

export const HotsiteInnerPage = (): React.ReactElement => {
  const location = useLocation()
  return (
    <HotsitePageWrapper>
      {location.pathname !== ROUTES.HOTSITE.INNOVATION_MAP ? (
        <HotsiteHeader logoWidth="184px" showDemoButton={false} />
      ) : (
        <></>
      )}
      <HotsiteContentWrapper>
        <Outlet />
      </HotsiteContentWrapper>
      <HotsiteFooter />
    </HotsitePageWrapper>
  )
}
